import React from 'react'
import { twMerge } from 'tailwind-merge'

interface ContentGridProps {
  children: React.ReactNode
  className?: string
}

const ContentGrid = ({ children, className }: ContentGridProps) => {
    return <div className={twMerge('grid md:grid-cols-2 content-grid', className)}>{children}</div>
}

export default ContentGrid
